'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadI18n = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _createStandardI18nProvider = require('I18n/init/providers/createStandardI18nProvider');

var _createStandardI18nProvider2 = _interopRequireDefault(_createStandardI18nProvider);

var _registerAllData = require('I18n/init/register/lazy/registerAllData');

var _registerAllData2 = _interopRequireDefault(_registerAllData);

var _en = require('i2l?query=sporks!../../lang/en.lyaml');

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadI18n = exports.loadI18n = function loadI18n() {
  var i18nConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var I18nProvider = (0, _createStandardI18nProvider2.default)();
  var langAvailable = _q2.default.Promise.all([I18nProvider.register(_en2.default), (0, _registerAllData2.default)(I18nProvider)]);

  I18nProvider.setLocale(i18nConfig);

  return langAvailable;
};